import { message } from 'antd';
import axios from 'axios';
import { tomcatHost, cloudFrontCdnUrl } from '../config/properties';
import { getAuthToken } from '../utils/authUtils';


import { solicitationStatus } from '../pages/SolicitationDetail/graphql';
// src\pages\SolicitationDetail\graphql.js

export async function downloadFile(url, fileExtension, fileName, jwtToken, callbackFunction = null) {
    let fileType
    switch (fileExtension) {
        case 'csv':
            fileType = "text/csv"
            break;
        case 'pdf':
            fileType = "application/pdf";
            break;
        default:
            break;
    }
    const config = {
        responseType: 'blob',
        headers: {
            Authorization: jwtToken,
        }
    }

    axios.get(url, config)
        .then(res => {
            if (res.data.type !== fileType) {
                console.log("FILE NOT FOUND");
                message.success('File not found', 3);
            } else {
                console.log("FILE FOUND");
                callbackFunction(false);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([res.data]));
                link.setAttribute('download', `${fileName}.${fileExtension}`);
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(error => {
            console.log(error);
        });

}


export async function getSolicitationInfoPdf(solNum) {
    let solStatus = '';
    await solicitationStatus(solNum)
        .then(res => {
            solStatus = res.solicitationStatus.status;
        })
        .catch(error => {
            console.log(error);
        });

    const jwtToken = getAuthToken();
    const config = {
        responseType: 'blob',
        headers: {
            Authorization: jwtToken,
        }
    }

    axios.get(`${cloudFrontCdnUrl}/${tomcatHost}/solicitations/pdf/solnum/${solNum}`, config)
        .then(res => {
            if (res.data.type !== "application/pdf" && solStatus !== "Closed") {
                console.log(`PDF INFO NOT FOUND FOR SOLICITATION ${solNum} `);
              // message pop up disabled related to NFFS-1660
              //  message.success(`PDF NOT FOUND FOR Solicitation ${solNum}!`, 3).then(() => {
                   window.open(`https://www.dibbs.bsm.dla.mil/rfq/rfqrec.aspx?sn=${solNum}`, '_blank');
              //  });
            } else {
                console.log(`FOUND PDF INFO FOR SOLICITATION ${solNum}`);
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `solicitation-${solNum}.pdf`);
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(error => {
            console.log(error);
        });
}


// WEBPACK FOOTER //
// ./src/utils/fileDownload.js